<template>
  <c-app>
    <c-content>
      <section class="sign u-m-auto">
        <div class="sign__body">
          <h1 class="sign__title u-fs-24">Olvidó su Contraseña?</h1>
          <p class="sign__text">Ingrese su nombre de Usuario para recuperar su contraseña</p>
          <c-form>
            <c-form-field label="Usuario:">
              <c-form-input type="text" v-model="UserName"></c-form-input>
            </c-form-field>
            <c-form-field>
              <c-level>
                <router-link to="/login" slot="center">Regresar a Iniciar Sesión</router-link>
              </c-level>
            </c-form-field>
            <c-button type="danger" @click.prevent="forgot" block>Enviar Link de Recuperación</c-button>
          </c-form>
          <div style="text-align:center;">
          <img src="../assets/rmgridlogoBlue.png" alt="rmgrid" style="width:50%;margin-top:20px;">
          </div>
        </div>
        <footer class="sign__footer u-text-center">
          <p class="u-text-muted u-fs-12">RMGRID by Riverminds Cia. Ltda.<br>© 2017-2018. Todos los Derechos Reservados.</p>
        </footer>
      </section>
    </c-content>
  </c-app>
</template>

<script>
  export default {
    name: 'ForgotView',
    data() {
      return {
        baseServiceUrl: window.baseServiceUrl,
        UserName: ''
      }
    },
    methods: {
      forgot() {
        const vm = this.$toast.loading("Enviando link de Restauración a su correo...");
        this.$http.post(baseServiceUrl + 'api/accountapi/retrieveaccount', {
          UserName: this.UserName
        }).then(function(response){
          vm.hide();
            var EmailMessage = "Se ha enviado un link a su Email, de click en el link para reestablecer su contraseña!";
            if (response != null && response.body != null && response.body.Message != null)
            {
              EmailMessage += ", El correo ha sido enviado a " + response.body.Message;
            }
            this.$notify({
                type: 'success',
                title: 'Recuperación de contraseña',
                content: EmailMessage,
                closeable: true,
                duration: 10000
              });
            this.$router.replace('/login')
          
          }, function(e){

            vm.hide();
            if (e != null && e.body != null && e.body.Message != null)
            {
              this.errorMessage = e.body.Message;
            }

        });

      }
    }
  }
</script>




// WEBPACK FOOTER //
// src/views/forgot.vue